import LeaveRequest from '../child_components/LeaveRequest';
import CertificationRequest from '../child_components/CertificationRequest';
import EquipmentReservationRequest from '../child_components/EquipmentReservationRequest';
import TransferRequest from '../child_components/TransferRequest';
import EquipmentCheckout from '../child_components/EquipmentCheckout';
import InventoryCheckout from '../child_components/InventoryCheckout';
import { Route, Routes } from 'react-router-dom';

function Requests() {

    return(
        <div>
            <Routes>
                    <Route path='/leave' element={ <LeaveRequest /> } />
                    <Route path='/certification' element={ <CertificationRequest /> } />
                    <Route path='/equipment_reservation' element={ <EquipmentReservationRequest /> } />
                    <Route path='/equipment_checkout' element={ <EquipmentCheckout /> } />
                    <Route path='/inventory_transfer' element={ <TransferRequest /> } />
                    <Route path='/inventory_checkout' element={ <InventoryCheckout /> } />
            </Routes>
        </div>
    )
}

export default Requests;